// extracted by mini-css-extract-plugin
export default {"letUsBlock":"LetUsComponent_letUsBlock__nF-t-","dark":"LetUsComponent_dark__5-SWL","light":"LetUsComponent_light__8S-UG"};